/* src/app/core/layout/header/header.component.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
.cursor-pointer {
  cursor: pointer;
}
a,
a:visited {
  color: var(--highlight_primary);
}
.pg-all {
  padding: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-all {
    padding: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-all {
    padding: 20px;
  }
}
.pg-left {
  padding-left: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-left {
    padding-left: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-left {
    padding-left: 20px;
  }
}
.pg-right {
  padding-right: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-right {
    padding-right: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-right {
    padding-right: 20px;
  }
}
.pg-top {
  padding-top: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-top {
    padding-top: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-top {
    padding-top: 20px;
  }
}
.pg-bottom {
  padding-bottom: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-bottom {
    padding-bottom: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-bottom {
    padding-bottom: 20px;
  }
}
.mg-all {
  margin: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-all {
    margin: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-all {
    margin: 20px;
  }
}
.mg-left {
  margin-left: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-left {
    margin-left: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-left {
    margin-left: 20px;
  }
}
.mg-right {
  margin-right: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-right {
    margin-right: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-right {
    margin-right: 20px;
  }
}
.mg-top {
  margin-top: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-top {
    margin-top: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-top {
    margin-top: 20px;
  }
}
.mg-bottom {
  margin-bottom: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-bottom {
    margin-bottom: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-bottom {
    margin-bottom: 20px;
  }
}
h1 {
  font-size: 24px;
}
.min-width-50 {
  min-width: 50px;
}
.min-width-75 {
  min-width: 75px;
}
.min-width-100 {
  min-width: 100px;
}
.min-width-125 {
  min-width: 125px;
}
.min-width-150 {
  min-width: 150px;
}
.min-width-175 {
  min-width: 175px;
}
.min-width-200 {
  min-width: 200px;
}
.min-width-225 {
  min-width: 225px;
}
.min-width-250 {
  min-width: 250px;
}
.min-width-275 {
  min-width: 275px;
}
.min-width-300 {
  min-width: 300px;
}
.top-shadow {
  background-image:
    linear-gradient(
      to bottom,
      var(--background_primary),
      transparent);
}
.right-shadow {
  background-image:
    linear-gradient(
      to left,
      var(--background_primary),
      transparent);
}
.bottom-shadow {
  background-image:
    linear-gradient(
      to top,
      var(--background_primary),
      transparent);
}
.left-shadow {
  background-image:
    linear-gradient(
      to right,
      var(--background_primary),
      transparent);
}
.br-tile {
  border-radius: calc(var(--tile_border_radius) / 10 * 20px);
}
.br-form {
  border-radius: 18px;
}
.br-cover {
  border-radius: calc(var(--tile_border_radius) / 10 * 50px);
}
.br-circle {
  border-radius: 50%;
}
.uppercase {
  text-transform: uppercase;
}
.text-shadow {
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.bg-pri {
  background-color: var(--background_primary);
}
svg.fill path,
svg path.fill {
  stroke: transparent !important;
}
svg.stroke path,
svg path.stroke {
  fill: transparent !important;
}
svg path {
  stroke: var(--text_primary);
  fill: var(--text_primary);
}
svg.hover-highlight-primary:hover path {
  stroke: var(--highlight_primary);
  fill: var(--highlight_primary);
}
.main-container {
  margin-top: 125px;
  margin-bottom: 125px;
}
.line-clamp-1 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 1;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 1;
}
.line-clamp-2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 2;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 2;
}
.line-clamp-3 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 3;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 3;
}
.line-clamp-4 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 4;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 4;
}
.line-clamp-5 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 5;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 5;
}
* {
  scrollbar-width: thin;
}
.min-width-150 {
  min-width: 150px;
}
ul {
  list-style-type: none;
  white-space: nowrap;
}
.nav-header {
  z-index: 600;
  position: absolute;
  width: 100%;
  height: 95px;
  background-color: transparent;
  box-shadow: inset 0 70px 37px -17px var(--background_actionbar_5);
  transition: height 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), background-color 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  gap: 10px;
}
.nav-header .nav-hamburger {
  position: relative;
  width: 45px;
  height: 45px;
  max-width: 0px;
  max-height: 0px;
  border-radius: 50%;
  transform-origin: center;
  transition:
    max-width 0.35s cubic-bezier(0.02, 0.01, 0.47, 1),
    max-height 0.35s cubic-bezier(0.02, 0.01, 0.47, 1),
    margin-right 0.35s cubic-bezier(0.02, 0.01, 0.47, 1);
  flex: 1 0 auto;
}
.nav-header .nav-logo {
  max-width: 175px;
  height: 75px;
  flex: 0 0 auto;
  transition: height cubic-bezier(0.02, 0.01, 0.47, 1) 0.35s;
}
.nav-header .nav-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left;
}
.nav-header .nav-search {
  width: 100%;
  margin-left: 95px;
}
.nav-header .nav-search .search {
  position: relative;
  height: 40px;
  max-width: 600px;
  width: 100%;
}
.nav-header .nav-search .search input {
  width: 100%;
  height: 100%;
  background: var(--background_secondary);
  border: 1px solid;
  border-color: var(--text-primary);
  border-radius: 18px;
  color: var(--text-primary);
  text-indent: 40px;
  caret-color: var(--highlight_primary);
}
.nav-header .nav-search .search .search-button {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}
.nav-header .nav-search .search .search-button img {
  width: 16px;
  display: block;
}
.nav-header .nav-search .search .close-button {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}
.nav-header .nav-search .search .close-button img {
  width: 16px;
  display: block;
}
.nav-header .nav-search .search-filter {
  padding-left: 30px;
}
@media screen and (max-width: 768px) {
  .nav-header .nav-search {
    margin: 0px;
  }
}
.nav-header .nav-items {
  list-style-type: none;
  margin: 0px;
  margin-right: 50px;
  height: 100%;
}
.nav-header .nav-items li {
  margin-left: 45px;
  letter-spacing: 1px;
  font-weight: 400;
  cursor: pointer;
  position: relative;
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .nav-header .nav-items li {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .nav-header .nav-items li {
    font-size: 25.92px !important;
  }
}
.nav-header .nav-items li:before {
  position: absolute;
  content: "";
  width: 0px;
  top: 0px;
  transition: width 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  height: 7px;
  background-color: var(--highlight_primary);
  border-radius: 2px;
}
.nav-header .nav-items li:hover:before {
  width: 100%;
}
.nav-header .nav-items li.active:before {
  width: 100%;
}
.nav-header .nav-items.sidebar {
  position: absolute;
  top: 0px;
  left: -350px;
  transition: left 0.35s cubic-bezier(0.02, 0.01, 0.47, 1);
  height: 100vh !important;
  padding-left: 0px;
  width: 350px;
  background-color: var(--background_actionbar);
  z-index: -1;
  overflow-y: auto !important;
}
.nav-header .nav-items.sidebar.open {
  left: 0px;
  box-shadow: 3px -5px 10px rgba(0, 0, 0, 0.75);
}
.nav-header .nav-items.sidebar li {
  min-height: 70px;
  margin-left: 0px;
  padding-left: 60px;
  padding-right: 24px;
  flex: 0 0 auto;
  white-space: normal;
}
.nav-header .nav-items.sidebar li .nav-item-title {
  max-width: 100%;
  overflow-wrap: anywhere;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.nav-header .nav-items.sidebar li:before {
  position: absolute;
  content: "";
  height: 0px;
  left: 0px;
  transition: 0;
  width: 7px;
}
.nav-header .nav-items.sidebar li:hover:before {
  height: 100%;
  transition: 300ms;
}
.nav-header .nav-items.sidebar li.header-carpet {
  z-index: 1;
  position: sticky;
  top: 0px;
  left: 0px;
  width: 330px;
  height: 115px;
  background-color: var(--background_actionbar);
}
.nav-header .nav-items.sidebar li.header-carpet:before {
  display: none;
}
.nav-header .nav-actions {
  margin-left: auto;
  gap: 30px;
}
.nav-header .nav-actions li a {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .nav-header .nav-actions li a {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .nav-header .nav-actions li a {
    font-size: 23.04px !important;
  }
}
.nav-header .nav-actions > span:not(.nav-actions-auth):not(.dropdown) {
  display: block;
}
.nav-header .nav-actions > span:not(.nav-actions-auth):not(.dropdown).search-button,
.nav-header .nav-actions > span:not(.nav-actions-auth):not(.dropdown).messages-button {
  width: 25px;
}
.nav-header .nav-actions > span:not(.nav-actions-auth):not(.dropdown).search-button img,
.nav-header .nav-actions > span:not(.nav-actions-auth):not(.dropdown).messages-button img {
  width: 100%;
}
.nav-header .nav-actions > span:not(.nav-actions-auth):not(.dropdown) {
  cursor: pointer;
}
.nav-header .nav-actions .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}
.nav-header .avatar-profile {
  pointer-events: none;
}
.nav-header .nav-header .nav-actions-auth {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.nav-header .nav-header .nav-actions-auth > span {
  display: inline-flex;
}
.nav-header .nav-header .nav-actions-auth button {
  min-width: 140px;
}
.nav-header.scrolled {
  height: 80px;
  background-color: var(--background_actionbar_8);
}
.nav-header.scrolled .nav-logo {
  height: 45px;
  transition-delay: 200ms;
}
.nav-header.fixed {
  position: fixed;
  -webkit-transform: translateZ(0);
  top: 0px;
}
.nav-header.collapsed .nav-logo {
  max-height: 55px;
}
.nav-header.collapsed .nav-items {
  height: 0px;
  overflow: hidden;
  position: absolute;
}
.nav-header.collapsed .nav-hamburger {
  margin-right: 25px;
  max-width: 45px;
  max-height: 45px;
}
@media screen and (max-width: 768px) {
  .nav-header.collapsed .nav-hamburger {
    margin-right: 0;
  }
}
.nav-header .top-shadow {
  z-index: -1;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.8;
}
.sidebar-shadow {
  z-index: 599;
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: var(--background-primary_4);
}
:host::ng-deep ul.dropdown-menu {
  padding: 8px 0 16px;
  right: 0px;
  list-style: none;
  margin: 0;
}
:host::ng-deep .dropdown.headerDropdown {
  border: 1px solid;
  border-color: var(--text-primary);
  border-radius: calc(var(--input_border_radius) / 10 * 25px);
  margin-left: 24px;
}
:host::ng-deep .header-dropdown {
  width: 317px;
  right: -20px;
  background-color: var(--background_secondary);
  border: 1px solid var(--text_primary);
  border-radius: 18px;
  padding: 8px 0 16px;
  list-style: none;
  margin: 0;
}
:host::ng-deep .header-dropdown li {
  list-style: none;
}
:host::ng-deep .header-dropdown li.dropdown-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  margin-bottom: 4px;
}
:host::ng-deep .header-dropdown li.dropdown-header .info {
  color: var(--text_secondary);
}
:host::ng-deep .header-dropdown li > a.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: var(--text_primary);
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
  white-space: nowrap;
}
:host::ng-deep .header-dropdown li > a.dropdown-item:hover,
:host::ng-deep .header-dropdown li > a.dropdown-item:focus {
  background-color: var(--highlight_secondary_5);
}
:host::ng-deep .header-dropdown li > a.dropdown-item .dropdown-item-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  padding: 0;
}
:host::ng-deep .header-dropdown li > a.dropdown-item .dropdown-item-icon img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
:host::ng-deep .header-dropdown li > a.dropdown-item > span:last-child {
  flex: 1;
  line-height: 1.2;
}
:host::ng-deep .nav-actions svg {
  width: 25px;
  height: 25px;
}
:host::ng-deep .nav-actions svg path {
  fill: var(--text_primary);
}
:host::ng-deep .nav-hamburger svg {
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0;
  transform: translate(-50%, -50%);
  transition: opacity 0.35s cubic-bezier(0.02, 0.01, 0.47, 1);
}
:host::ng-deep .nav-hamburger svg path {
  stroke: var(--text_primary);
}
:host::ng-deep .nav-hamburger img {
  width: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0;
  pointer-events: none;
  cursor: default;
  transform: translate(-50%, -50%);
  transition: opacity 0.35s cubic-bezier(0.02, 0.01, 0.47, 1);
}
:host::ng-deep .collapsed .nav-hamburger svg,
:host::ng-deep .collapsed .nav-hamburger img {
  pointer-events: all;
  cursor: pointer;
  opacity: 1;
}
.custom-dropdown {
  position: relative;
  width: 100%;
  min-width: 150px;
}
.custom-dropdown ul {
  list-style-type: none;
  padding: 16px 0px;
  margin: 0;
}
.custom-dropdown ul li {
  cursor: pointer;
  padding: 8px;
}
.custom-dropdown ul li:hover,
.custom-dropdown ul li.selected {
  background-color: var(--highlight_secondary_5);
}
.custom-dropdown .dropdown-header {
  padding: 3px 16px;
  border: 1px solid var(--text_primary);
  cursor: pointer;
  border-radius: 18px;
  color: var(--text_primary);
  font-size: 21px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background-color: var(--background_secondary);
}
.custom-dropdown .dropdown-header span {
  font-size: 16px;
}
.custom-dropdown .dropdown-header .arrow-icon {
  display: flex;
  align-items: center;
  transition: transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
}
.custom-dropdown .dropdown-header .rotate-icon {
  transform: rotate(180deg);
}
.custom-dropdown .dropdown-list {
  position: absolute;
  margin-top: 4px;
  width: 100%;
  background-color: var(--background_secondary);
  color: var(--text_primary);
  border: 1px solid var(--text_primary);
  overflow-y: auto;
  z-index: 1000;
  border-radius: 18px;
  transition: opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), visibility 0s 0.25s;
  visibility: hidden;
  opacity: 0;
}
.custom-dropdown .fade-list {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), visibility 0s 0s;
}
.divide {
  margin-left: 60px;
  margin-right: 60px;
  color: var(--text_tertiary);
  opacity: 1;
}
:host {
  --sub-warn: #F5A623;
  --sub-warn-text: #FFC25C;
  --sub-danger: #FF6B6B;
}
.sub-pill {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 0 4px 0 16px;
  box-sizing: border-box;
  border-radius: 999px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
@supports not (backdrop-filter: blur(1px)) {
  .sub-pill {
    background: rgba(20, 22, 30, 0.7);
  }
}
.sub-pill svg path {
  fill: none;
}
.sub-pill--compact {
  height: 40px;
  padding: 0 16px;
  gap: 8px;
  font: inherit;
  font-weight: 600;
}
.sub-pill__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--sub-warn);
  box-shadow: 0 0 0 4px rgba(245, 166, 35, 0.25);
}
.sub-pill__btn {
  height: 34px;
  padding: 0 16px;
  border: 0;
  border-radius: 999px;
  background: #fff;
  color: #10121a;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}
.sub-pill--tomorrow {
  background: rgba(245, 166, 35, 0.24);
  border-color: rgba(245, 166, 35, 0.7);
}
.sub-pill--tomorrow .sub-pill__btn {
  background: var(--sub-warn);
  color: #1d1302;
}
.sub-pill--expired {
  background: rgba(255, 92, 92, 0.2);
  border-color: rgba(255, 107, 107, 0.7);
  font-weight: 600;
}
.sub-pill--expired .sub-pill__dot {
  background: var(--sub-danger);
  box-shadow: none;
}
.sub-pill--promo {
  background: rgba(37, 105, 184, 0.24);
  background: color-mix(in srgb, var(--highlight_primary, #2569B8) 24%, transparent);
  border-color: rgba(37, 105, 184, 0.7);
  border-color: color-mix(in srgb, var(--highlight_primary, #2569B8) 70%, transparent);
}
.sub-pill--promo .sub-pill__btn {
  background: var(--highlight_primary, #2569B8);
  color: #fff;
}
.sub-pill__gift {
  flex: none;
}
.sub-pill__gift path,
.sub-pill__gift rect {
  stroke: currentColor;
  fill: none;
}
.avatar__dot {
  position: absolute;
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #10121a;
  background: var(--sub-warn);
  pointer-events: none;
}
.avatar__dot--danger {
  background: var(--sub-danger);
}
@media (max-width: 1100px) {
  .sub-pill .sub-pill__text,
  .sub-pill .sub-pill__btn,
  .sub-pill .sub-pill__label {
    display: none;
  }
  .sub-pill {
    width: 44px;
    padding: 0;
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .nav-header .nav-logo {
    flex: 0 1 auto;
    min-width: 56px;
  }
  .nav-header .nav-actions:has(.sub-pill) {
    gap: 14px;
  }
  .sub-pill {
    width: 36px;
    height: 36px;
  }
}
/*# sourceMappingURL=header.component.css.map */
